import React from "react";
import IconHolder from "../../../../Resources/svg/Icons/IconHolder";
import moment from "moment";
import AlertMessage from "../../../../Components/alertMessage";
import { BeneficiaryFormRv } from "../../beneficiaryFormRv";

interface UpdateInsuredCardProps {
  selectedAssured: any;
  showWarningUserValidation: boolean;
  handleValidateUser: (state: boolean) => void;
  submitAssured: (data: any) => Promise<void>;
  isOpen: boolean;
  alert: string;
}

const UpdateInsuredCard = ({
  selectedAssured,
  showWarningUserValidation,
  handleValidateUser,
  submitAssured,
  isOpen,
  alert,
}: UpdateInsuredCardProps) => {
  return (
    <>
      <div className="card-verify card-verify_rv">
        <div className="card-verify__header">
          <IconHolder />
          <div className="card-verify__title"> ASEGURADO</div>
        </div>
        <div className="card-verify__body">
          <div className="card-verify__quote">Nombres:</div>
          <div className="card-verify__data">
            {selectedAssured.primerNombre}{" "}
            {selectedAssured.segundoNombre ? selectedAssured.segundoNombre : ""}
          </div>
        </div>
        <div className="card-verify__body">
          <div className="card-verify__quote">Apellidos:</div>
          <div className="card-verify__data">
            {selectedAssured.apellidoPaterno +
              " " +
              selectedAssured.apellidoMaterno}
          </div>
        </div>
        <div className="card-verify__body">
          <div className="card-verify__quote">Fecha de nacimiento:</div>
          <div className="card-verify__data">
            {moment(selectedAssured.fechaNacimiento).format("DD/MM/YYYY")}
          </div>
        </div>
      </div>

      <div className="card-verify card-verify_rv">
        <div className="card-verify__header">
          <IconHolder />
          <div className="card-verify__title"> OTROS DATOS</div>
        </div>
        {showWarningUserValidation && (
          <AlertMessage
            background="#FFEFD8"
            margin="0 0px -16px"
            icono={alert}
            mensaje="Parece que los nombres y apellidos no coinciden con el número de documento. Revisa que los datos estén correctos e inténtalo nuevamente."
          />
        )}
        <BeneficiaryFormRv
          beneficiary={selectedAssured}
          existsErrors={false}
          type={"INSURED"}
          validationBeneficiary={(state: any) => handleValidateUser(state)}
          onSubmit={submitAssured}
          isOpen={isOpen}
        ></BeneficiaryFormRv>
      </div>
    </>
  );
};

export default UpdateInsuredCard;
